// removed by extract-text-webpack-plugin
module.exports = {"container":"_3ByCGgQf8EDTtf_IqIiCvV","left-arrow":"_2yUb81sBUfl3GekV-T76nJ","leftArrow":"_2yUb81sBUfl3GekV-T76nJ","right-arrow":"_29Ghul8MA3MBupV4cLetSH","rightArrow":"_29Ghul8MA3MBupV4cLetSH","left-arrow-text":"_24uct_ZpSY9rArlbAtnVs2","leftArrowText":"_24uct_ZpSY9rArlbAtnVs2","right-arrow-text":"_2uBjM4IN8ytNuO4DAnif35","rightArrowText":"_2uBjM4IN8ytNuO4DAnif35","left-arrow-img":"_2i1uhXBiNcyEMigZX-l6K1","leftArrowImg":"_2i1uhXBiNcyEMigZX-l6K1","right-arrow-img":"_2C-5YfZpYc4ITkesyw0OUd","rightArrowImg":"_2C-5YfZpYc4ITkesyw0OUd","arrow-box":"sYnj1KJ6v8enGGcDZ14HO","arrowBox":"sYnj1KJ6v8enGGcDZ14HO"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/storydoc/storydoc.css
// module id = 280
// module chunks = 0